import React from 'react';

import { getApiBase } from '../Env/apiBase';
import { determineEnvironmentFromApiBase } from '../Env/rover';

import { useRoverStatsigUser } from './hooks/useRoverStatsigUser';
import { useStatsigUserUpdates } from './hooks/useStatsigUserUpdates';
import { getStatsigConfig, StatsigPlatform } from './config';
import { StatsigProvider, useClientAsyncInit } from './StatsigLib';

export type Props = {
  children: React.ReactNode;
};

const RoverStatsigProvider = ({ children }: Props): JSX.Element => {
  const { roverStatsigUser } = useRoverStatsigUser();

  const apiBase = getApiBase();
  const apiEnvironmentName = determineEnvironmentFromApiBase(apiBase);
  const { apiKey, clientOptions } = getStatsigConfig(apiEnvironmentName, StatsigPlatform.REACT);

  // Initialize Statsig client asynchronously with the API key and any initial user data, from
  // https://docs.statsig.com/client/javascript-sdk/init-strategies/#3-asynchronous-initialization---not-awaited
  const { client } = useClientAsyncInit(apiKey, roverStatsigUser, clientOptions);

  useStatsigUserUpdates(client, roverStatsigUser);

  return <StatsigProvider client={client}>{children}</StatsigProvider>;
};

export default RoverStatsigProvider;
